import { useParams } from 'next/navigation';
import { useState } from 'react';
import { useProductSizeSelect } from 'pages/ProductDetail/hooks';
import { getCurrencySymbol } from 'modules/formatter';
import { IUseGiftCardTile } from '../types';

export const useGiftCardTile = (data: IUseGiftCardTile) => {
  const { product, onAddToCart, onAddStorageGiftCardImage } = data;
  const { availableAmountsImages } = product;

  const { locale } = useParams();

  const [openModal, setOpenModal] = useState(false);
  const { hasSizes, sizeOptions, selectedVariant, setSelectedVariant } =
    useProductSizeSelect(product, product.referenceKey, true, true);

  const activeVariant =
    product.variants?.find(
      (variant) => variant.referenceKey === selectedVariant,
    ) || product.variants?.[0];

  const relevantImage = availableAmountsImages?.find(({ filename }) => {
    /** get amount key from file name */
    const amountKey = filename
      .slice(
        0,
        filename.lastIndexOf('.'),
      ) /** get file name without extension */
      .split('_')
      .slice(-2)
      .join('_');

    return amountKey === selectedVariant;
  });

  const currency = getCurrencySymbol(
    locale as string,
    product.price.currencyCode,
  );

  const isDisabled = hasSizes && !selectedVariant;

  const toggleModal = () => {
    setOpenModal((isOpen) => !isOpen);
  };

  const handleAddToCart = () => {
    if (!activeVariant?.referenceKey) {
      return;
    }

    if (relevantImage) {
      onAddStorageGiftCardImage(
        activeVariant.referenceKey,
        relevantImage.filename,
      );
    }

    onAddToCart(activeVariant.referenceKey, 1, product.limitForCart);
  };

  return {
    select: { sizeOptions, selectedVariant, setSelectedVariant },
    modal: { openModal, toggleModal },
    handleAddToCart,
    product: { currency, relevantImage },
    isDisabled,
  };
};
